module.exports = __webpack_public_path__ + "static/img/teaching_3.4149af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/teaching_3.png
// module id = SCYz
// module chunks = 0